//Логіка сторінки Cart
import { product, updateCartCount, updateWishCount } from './js/modal';
updateCartCount();
updateWishCount();
